import { h } from 'preact'
import clsx from 'clsx'

interface BadgeData {
  title: string
  text_colour: string
  background_colour?: string
  background_colour_pdp?: string
  image?: string
  content_drawer?: string
  off_messaging?: string[]
}

interface BadgeProps {
  badge: BadgeData
  badgeLocation?: string
  product?: any
}

const TextBadge = ({ badge, badgeLocation, product }: { badge: BadgeData; badgeLocation?: string; product?: any }) => {
  let showOffMessaging = false
  let salePercentage = 0

  if (product && product.variants && product.variants[0]) {
    const variant = product.variants[0]
    const offMessagingString = badge.off_messaging?.join(',') || ''

    if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
      if (badgeLocation === 'PLP' && offMessagingString.includes('PLP')) {
        showOffMessaging = true
      } else if (badgeLocation === 'PDP' && offMessagingString.includes('PDP')) {
        showOffMessaging = true
      }

      if (showOffMessaging) {
        salePercentage = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
      }
    }
  }

  return (
    <div
      className={clsx('shrink-0 flex size-fit text-[--text-colour] bg-[--bg-colour]', {
        'px-0.5 py-0.25 rounded-badge overflow-hidden': badge.background_colour
      })}
      style={{
        '--text-colour': badge.text_colour,
        '--bg-colour': badge.background_colour || 'transparent'
      } as React.CSSProperties}
    >
      <span className="text-xs font-medium">
        {badge.title}
        {showOffMessaging && ` | Save ${salePercentage}%`}
      </span>
    </div>
  )
}

const ImageBadge = ({ badge }: { badge: BadgeData }) => (
  <div className="flex size-fit max-w-[75px] children:size-auto children:size-contain">
    <img src={badge.image} alt={badge.title || 'Badge'} />
  </div>
)

export const Badge = ({ badge, badgeLocation, product }: BadgeProps) => {
  if (!badge) return null

  const content = badge.image ? <ImageBadge badge={badge} /> : <TextBadge badge={badge} badgeLocation={badgeLocation} product={product} />

  if (badge.content_drawer) {
    const contentDrawerId = badge.content_drawer.split('/').pop()
    const modalId = `content-drawer-${contentDrawerId}`

    const handleModalClick = () => {
      const modalElement = document.querySelector(`x-modal[data-id="${modalId}"]`)
      if (modalElement) {
        const modalInstance = modalElement as any
        if (modalInstance.handleShow) {
          modalInstance.handleShow()
        }
      }
    }

    return (
      <button
        type="button"
        className="flex size-fit link-fade"
        data-modal-parent={modalId}
        data-modal-role="open"
        aria-label="Open content drawer"
        onClick={handleModalClick}
      >
        {content}
      </button>
    )
  }

  return (
    <div className="flex size-fit">
      {content}
    </div>
  )
}
